import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    myCircle: PropTypes.object.isRequired,
  },
  getInitialState() {
    return {};
  },
  componentDidMount() {},
  render() {
    return (
      <div className="circle-icon-and-name-display mt20">
        <p
          className="circle-icon mr20"
          style={{
            backgroundImage: `url(${
              this.props.myCircle.circle.main_image_thumb
            })`,
          }}
        />
        <p className="circle-name line-1 bold">
          <a
            className="color-main"
            href={`/events/new/${this.props.myCircle.circle.id}`}
          >
            {this.props.myCircle.circle.name}
          </a>
        </p>
      </div>
    );
  },
});
